import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export const OverlayMarker: React.FC<{
    map: any;
    position: { lat: number; lng: number };
    children: React.ReactNode;
}> = ({ map, position, children }) => {
    const [container] = useState(document.createElement('div'));
    const overlayRef = useRef<any>(null);

    useEffect(() => {
        if (!map) return;

        class ReactOverlay extends window.google.maps.OverlayView {
            container: HTMLElement;
            position: { lat: number; lng: number };

            constructor(container: HTMLElement, position: { lat: number; lng: number }) {
                super();
                this.container = container;
                this.position = position;
            }

            onAdd() {
                const panes = this.getPanes();
                if (panes) {
                    this.container.style.position = 'absolute';
                    panes.overlayMouseTarget.appendChild(this.container);
                }
            }

            draw() {
                const projection = this.getProjection();
                if (projection) {
                    const point = projection.fromLatLngToDivPixel(new window.google.maps.LatLng(this.position));
                    if (point) {
                        this.container.style.left = point.x + 'px';
                        this.container.style.top = point.y + 'px';
                    }
                }
            }

            onRemove() {
                if (this.container.parentNode) {
                    this.container.parentNode.removeChild(this.container);
                }
            }
        }

        const overlay = new ReactOverlay(container, position);
        overlay.setMap(map);
        overlayRef.current = overlay;

        return () => {
            overlay.setMap(null);
        };
    }, [map, container]);

    useEffect(() => {
        if(overlayRef.current) {
            overlayRef.current.position = position;
            overlayRef.current.draw();
        }
    }, [position.lat, position.lng]);

    return createPortal(children, container);
};
